import type { Folder } from "@cohesive/api-client";

/** Breadcrumb trail from the workspace root to `folderId`, walking
 *  `parent_folder_id`. Capped so a cyclic parent chain can't hang render. */
export function buildFolderTrail(
  folders: Folder[],
  folderId: string | null,
): Folder[] {
  if (!folderId) return [];
  const byId = new Map(folders.map((f) => [f.id, f]));
  const trail: Folder[] = [];
  let cur: string | null = folderId;
  for (let i = 0; i < 64 && cur; i++) {
    const f = byId.get(cur);
    if (!f) break;
    trail.unshift(f);
    cur = f.parent_folder_id ?? null;
  }
  return trail;
}
